import React, { FunctionComponent } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { DimensionLabelType } from '@paragon/contract-library';

interface Props {
  value: DimensionLabelType;
  onChange: (value: DimensionLabelType) => void;
}

export const DimensionLabelTypeSelect: FunctionComponent<Props> = (props) => (
  <FormControl margin="normal" variant="standard">
    <InputLabel htmlFor="dimension-label-type">Dimension Labels</InputLabel>
    <Select
      autoWidth
      value={props.value}
      inputProps={{
        id: 'dimension-label-type',
      }}
      onChange={(event) => {
        props.onChange(event.target.value as DimensionLabelType);
      }}
      label="Dimension Labels"
    >
      <MenuItem value="Separated">Separated</MenuItem>
      <MenuItem value="Cumulative">Cumulative</MenuItem>
      <MenuItem value="Combined">Combined</MenuItem>
    </Select>
  </FormControl>
);
